var map = {
	"./arcane.webp": 706,
	"./aurora.webp": 292,
	"./b1.webp": 73,
	"./b2.webp": 396,
	"./b3.webp": 639,
	"./bera.webp": 248,
	"./croa.webp": 925,
	"./default.webp": 185,
	"./elysium.webp": 786,
	"./inosis.webp": 77,
	"./luna.webp": 678,
	"./nova.webp": 466,
	"./r1.webp": 697,
	"./r2.webp": 28,
	"./red.webp": 751,
	"./scania.webp": 771,
	"./union.webp": 703,
	"./zenith.webp": 424
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 282;